import { defineStore } from "pinia";
import type { BannerSections } from "@/types/banners";
import type { Settings } from "@/types/settings";

export const useSettingsStore = defineStore("settings", () => {
  const settingsData = useState<Settings>('settingsData', () => ({
    // general_site_title: "Cometa Gaming",
    // general_site_color: '#ff4c3e',
    // general_secondary_color: '#ff4c3e',
    // general_background_color: '#f5f5f5',
    // general_social_telegram: '',
    // general_social_youtube: '',
    // general_social_instagram: '',
    // general_social_facebook: '',
    // general_social_twitter: '',
    // general_social_tiktok: '',
    // general_time_zone: 'America/Sao_Paulo',
    // general_degrade_effect: true,
    // general_live_chat: '',
    // deposit_min: 100,
    // deposit_max: 2000000,
    // withdraw_min: 2000,
    // withdraw_max: 200000,
    // pixel_gtm: '',
    // maintence: true,
    // cometa_sports_book: false,

    general_site_title: "Placeholder",
    general_logo: "https://placehold.co/300x150",
    general_site_color: "#ff4c3e",
    general_secondary_color: "#ff4c3e",
    general_background_color: "#f5f5f5",
    general_time_zone: "America/Sao_Paulo",
    general_register: false,
    general_social_facebook: "#",
    general_social_telegram: "#",
    general_social_twitter: "#",
    general_social_youtube: "#",
    general_social_instagram: "#",
    general_social_tiktok: "#",
    general_live_chat: "null",
    general_show_chat_sidebar: true,
    general_show_chat_widget: true,
    general_show_chat_user_menu: true,
    general_support: "#",
    general_webhook: "#",
    general_menu_site: [],
    general_degrade_effect: false,
    general_menu_start: [],
    general_menu_mobile: [],
    general_site_favicon: "https://placehold.co/30x30",
    general_credit_entry: false,
    casino_enabled: false,
    casino_bet_default: 50,
    casino_bet_min_total: 10,
    casino_bet_max_total: 2000,
    sport_enabled: false,
    sport_bet_min_total: 50,
    sport_bet_min_single: 10,
    sport_bet_multiple: 10,
    deposit_enabled: false,
    deposit_min: 100,
    deposit_max: 5000000,
    deposit_rollover: 1,
    deposit_enable_popup: false,
    deposit_popup_timer: 10,
    deposit_popup_message: "",
    deposit_popup_values: "10,20,30",
    withdraw_enabled: false,
    withdraw_min: 100,
    withdraw_max: 10000,
    withdraw_daily: 1,
    withdraw_daily_type: false,
    withdraw_daily_request: 1,
    withdraw_affiliate_day: [1],
    withdraw_auto_kyc: true,
    withdraw_enable_auto_disable_withdraw: false,
    withdraw_max_interval_withdraw: 0,
    withdraw_max_interval_withdraw_start: "",
    withdraw_max_interval_withdraw_end: "string",
    withdraw_max_hourly_withdraw: 0,
    withdraw_limit_variation_withdraw: 0,
    pixel_gtm: "",
    refer_enabled: false,
    refer_min: 100,
    refer_max_refer: 100,
    refer_referrer_wallet_type: 100,
    refer_referrer_amount: 0,
    refer_referee_enabled: false,
    refer_referee_wallet_type: 0,
    refer_referee_amount: 0,
    refer_referee_rollover_id: 0,
    refer_referrer_rollover_id: 0,
    cometa_sports_book: false,
    cometa_withdraw_address: false,
    cometa_notifications: false,
    cometa_bi: false,
    bonus_enabled: false,

    maintence: true,

    colors_primary: "#ff4c3e",
    colors_secondary: "#ff4c3e",
    colors_topbar: "#ff4c3e",
    colors_topbar_text: "#ff4c3e",
    colors_topbar_action: "#ff4c3e",
    colors_topbar_action_text: "#ff4c3e",
    colors_navbar: "#ff4c3e",
    colors_footer: "#ff4c3e",
    colors_background: "#ff4c3e",
    colors_card: "#ff4c3e",
    colors_sidebar: "#ff4c3e",
    colors_separator: "#ff4c3e",
    colors_input: "#ff4c3e",

    cometa_sportsbook_css: "",

    sport_sportbook_type: ""
  }));

  // Convert modalBanners to individual useState properties
  const modalBannersRegister = useState<BannerSections['register']>('modalBannersRegister', () => []);
  const modalBannersLogin = useState<BannerSections['login']>('modalBannersLogin', () => []);
  const modalBannersDeposit = useState<BannerSections['deposit']>('modalBannersDeposit', () => []);
  const modalBannersPasswordRecovery = useState<BannerSections['password_recovery']>('modalBannersPasswordRecovery', () => []);
  const modalBannersRegisterCancel = useState<BannerSections['register_cancel']>('modalBannersRegisterCancel', () => []);
  const modalBannersSponsors = useState<BannerSections['sponsors']>('modalBannersSponsors', () => []);
  const modalBannersMajority = useState<BannerSections['majority']>('modalBannersMajority', () => []);

  // Create computed objects to maintain the same API
  const settings = computed(() => settingsData.value);
  const state = computed(() => ({
    modalBanners: {
      register: modalBannersRegister.value,
      login: modalBannersLogin.value,
      deposit: modalBannersDeposit.value,
      password_recovery: modalBannersPasswordRecovery.value,
      register_cancel: modalBannersRegisterCancel.value,
      sponsors: modalBannersSponsors.value,
      majority: modalBannersMajority.value
    }
  }));

  const getSettings = async () => {
    try {
      const { data } = await useFetch("/v2/settings/");
      if (data.value) {
        settingsData.value = data.value;
      }
    } catch (error) {
      console.error("Houve um erro ao carregar as configurações do site:", error);
    }
  };

  const getModalBanners = async () => {
    try {
      const { data } = await useFetch<BannerSections>(`/v2/images/`);
      if (data.value) {
        modalBannersRegister.value = data.value.register ?? modalBannersRegister.value;
        modalBannersLogin.value = data.value.login ?? modalBannersLogin.value;
        modalBannersDeposit.value = data.value.deposit ?? modalBannersDeposit.value;
        modalBannersPasswordRecovery.value = data.value.password_recovery ?? modalBannersPasswordRecovery.value;
        modalBannersRegisterCancel.value = data.value.register_cancel ?? modalBannersRegisterCancel.value;
        modalBannersSponsors.value = data.value.sponsors ?? modalBannersSponsors.value;
        modalBannersMajority.value = data.value.majority ?? modalBannersMajority.value;
      }
    } catch (error) {
      console.error("Houve um erro ao carregar os banners:", error);
    }
  };

  return {
    settings,
    state,
    getSettings,
    getModalBanners,
  };
});